import { render } from "./Schlafworkshop.vue?vue&type=template&id=42dbe0e5&scoped=true"
import script from "./Schlafworkshop.vue?vue&type=script&lang=js"
export * from "./Schlafworkshop.vue?vue&type=script&lang=js"

import "./Schlafworkshop.vue?vue&type=style&index=0&id=42dbe0e5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42dbe0e5"]])

export default __exports__